import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20
    },
    wrap: {
        marginBottom: 12, 
        width: 'calc(100% - 40px)', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        flexDirection: 'column', 
        padding: 20
    },
    block: {
        display: 'flex', 
        justifyContent: 'center', 
        marginBottom: 12
    },
    helper: {
        color: '#fff',
        fontSize: 16,
        fontFamily: 'PT-sans, sans-serif', 
    }
}))

export {
    useStyles
}